import React from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import {
  MULTI_SELECT_LIMIT_TAGS,
  ticketStatusOptions,
} from "../utils/constants";
import { formClasses } from "../styles/AutocompleteStyles";
import { TicketStatusOptionsTypes } from "../utils/types";
interface Props {
  onChange: (newValue: TicketStatusOptionsTypes[]) => void;
  value: TicketStatusOptionsTypes[];
  handleClear: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  label?: string;
  placeholder?: string;
}
const MultipleTicketStatusSelect = ({
  onChange,
  handleClear,
  onKeyDown,
  value,
  label,
  placeholder,
}: Props) => {
  return (
    <>
      <div className="multi-select-autocomplete">
        <Autocomplete
          className={formClasses.inputRoot}
          options={ticketStatusOptions}
          limitTags={MULTI_SELECT_LIMIT_TAGS}
          multiple
          onChange={(e, newValue) => {
            onChange(newValue);
          }}
          renderOption={(props, option) => {
            const selectedSuppliers = value.map(({ value }) => value);

            const checked = selectedSuppliers.includes(
              (option as TicketStatusOptionsTypes).value
            );

            return (
              <li {...props} key={(option as TicketStatusOptionsTypes).value}>
                <Checkbox style={{ marginRight: 8 }} checked={checked} />
                {(option as TicketStatusOptionsTypes).label}
              </li>
            );
          }}
          onKeyDown={onKeyDown}
          openOnFocus
          forcePopupIcon
          value={value}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              className={formClasses.formControlRoot}
              label={label}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              placeholder={value.length ? "" : placeholder}
            />
          )}
        />
      </div>

      {/* <LoadingModal flag={loading} /> */}
    </>
  );
};

export default MultipleTicketStatusSelect;
